import React from 'react';
import './OurStory.css'; // Import CSS for styling

const OurStory = () => {
  return (
    <div className="our-story-container">
      <h1 className="our-story-title">Our Story</h1>
      <div className="our-story-content">
        <p className="our-story-paragraph">
        Abstinent Adolescents was founded by Jayla Richardson. During her freshman year of college, she felt like an outcast for her decision to commit to abstinence. After seeing the lack of community on campus that was committed to abstinence, she decided to make her own community. Jayla originally intended for the organization to be an official organization on North Carolina A&T's campus named Abstinent Aggies. After getting rejected as an organization by the Council of Presidents, she launched the organization anyway, later changing the name to Abstinent Adolescents. The organization officially launched in Fall 2022 with a total of 8 E-board members. Since then, Abstinent Adolescents has grown to over 65 members at North Carolina A&T and UNC Greensboro. By God's grace, Abstinent Adolescents has fostered a community of college students committed to abstinence and continues to do so. We desire to continue growing our organization into local communities by connecting our college student network to teens via schools, churches, and other youth groups.
        </p>
        <img src="/images/contract.jpg" alt="Contract" className="contract-image" />
      </div>

      <div className="youtube-section">
        <h2>Watch Our Journey</h2>
        <iframe
          className="youtube-embed"
          src="https://www.youtube.com/embed/79c6x97McnE"
          title="Our Story Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default OurStory;
